import { useMutation } from "@tanstack/react-query";
import { useNotification, useTranslate } from "@refinedev/core";

import { ApiError } from "@shared/types";
import { Voucher } from "@modules/vouchers/types";
import { VoucherFormValues } from "@modules/vouchers/validations";
import { editVoucherService } from "./service";
import { UseEditVoucherMutationOptions } from "./types";

export function useEditVoucherMutation(
  options?: UseEditVoucherMutationOptions
) {
  const { open } = useNotification();
  const translate = useTranslate();

  return useMutation<Voucher, ApiError, { id: string; data: VoucherFormValues }>({
    mutationFn: ({ id, data }) => editVoucherService(id, data),
    onSuccess: () => {
      open?.({
        type: "success",
        message: translate("voucher_batch_admin.success.edit"),
      });
    },
    onError: (error: ApiError) => {
      open?.({
        type: "error",
        message: error.response.data.error,
      });
    },
    ...options,
  });
}
